export default {
  PackagesPlacement__ARIA_LABEL__CURRENT_PAGE: "Current page is ",
  PackagesPlacement__ARIA_LABEL__NEXT: "Next page",
  PackagesPlacement__ARIA_LABEL__PAGE_COUNT: "Total number of pages",
  PackagesPlacement__ARIA_LABEL__PREVIOUS: "Previous page",
};
